import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';
import ChooseBountyAmount from './ChooseBountyAmount';
import Backers from './Backers';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import ItemList from 'flarum/common/utils/ItemList';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import BountyAddedEventPost from './BountyAddedEventPost';
import type Mithril from 'mithril';

export default function () {
  app.postComponents.bountyAdded = BountyAddedEventPost;

  const canAddBounty = function (discussion: Discussion) {
    const tags = discussion.tags() || [];
    const bountyTags = tags.filter((tag) => tag && tag.blomstraBountyProduct());

    return app.session?.user?.exists && bountyTags.length > 0;
  };

  const enablePayToSupport = function (discussion: Discussion) {
    if (canAddBounty(discussion)) {
      discussion
        .save({
          blomstra_bounties_enabled: true,
        })
        .then(() => m.redraw());
    }
  };

  extend(DiscussionPage.prototype, 'sidebarItems', function (this: DiscussionPage, items: ItemList<Mithril.Children>) {
    const discussion = this.discussion;
    const tags = discussion!.tags() || [];

    const bountyTag = tags.find((tag) => tag && tag.blomstraBountyProduct());

    if (bountyTag && discussion!.backers() && discussion.backers().length > 0) {
        items.add('backers', <Backers discussion={discussion} />, 90);
    }

    if (bountyTag && discussion!.bountiesEnabled()) {
      items.add(
        'add-bounty',
        <Button
          className="Button Button--primary"
          onclick={() => app.modal.show(ChooseBountyAmount, { for: this.discussion, product: bountyTag.blomstraBountyProduct() })}
        >
          {app.translator.trans('blomstra-payments.forum.bounties.purchase-control')}
        </Button>,
        90
      );
    }

    if (bountyTag && !discussion!.bountiesEnabled() && discussion!.canEnableBounties()) {
      items.add(
        'enable-bounties',
        <Button className="Button" icon="fas fa-hand-holding-heart" onclick={() => enablePayToSupport(discussion!)}>
          {app.translator.trans('blomstra-payments.forum.bounties.enable-control')}
        </Button>,
        90
      );
    }
  });

  extend(DiscussionListItem.prototype, 'infoItems', function (this: DiscussionListItem, items: ItemList<Mithril.Children>) {
    const discussion = this.attrs.discussion;

    const bountyTag = (discussion!.tags() || []).find((tag) => tag && tag.blomstraBountyProduct());

    if (bountyTag && discussion!.bountiesEnabled()) {
      items.add(
        'bounty',
        <span className="TagLabel">
          {app.translator.trans('blomstra-payments.forum.backers-widget.label', {
            currency: discussion.bountyCurrencySymbol(),
            sum: discussion.totalBounty(),
          })}
        </span>,
        // Before tags which is 8, but before reply username which is 0
        // Otherwise it's pushed out of the screen by a combination of many tags + long usernames on mobile
        5
      );
    }
  });

  extend(DiscussionListState.prototype, 'sortMap', function (map) {
    if (app.forum.attribute('blomstra-payments.bounties-enabled')) {
      map.mostBacked = '-blomstraTotalBounty';
    }

    return map;
  });
}
